import { render, staticRenderFns } from "./GradeManage.vue?vue&type=template&id=4c66af93"
import script from "./GradeManage.vue?vue&type=script&lang=js"
export * from "./GradeManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports